import React from 'react';
var VeltWireframe = function (props) {
    var children = props.children;
    return (React.createElement("velt-wireframe", { style: { display: 'none' } }, children));
};
export default VeltWireframe;
